import { LomaProvider } from "src/context/LomaContext";
import { lazy, useEffect } from "react";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
const LomaLayout = lazy(() => import("./layout/LomaLayout"));

export default function LomaCore() {
  useEffect(() => {
    localStorage.setItem("lastKnownUrl", window.location.pathname);
  }, []);

  return (
    <LomaProvider>
      <LazyLoader>
        <LomaLayout />
      </LazyLoader>
    </LomaProvider>
  );
}
